/* eslint-disable max-lines */
import '../assets/font-import.css';
export * from './helpers';
export const theme = {
    colors: {
        // #region Brand colours
        /** Brand: Brand Blue */
        BB100: 'rgba(67,104,231,1)',
        /** Brand: Green Pine */
        GR100: 'rgba(49,130,100,1)',
        /** Brand: Pink Coral */
        PI100: 'rgba(236,131,129,1)',
        /** Brand: Purple Heather */
        PU100: 'rgba(134,77,150,1)',
        /** Brand: Yellow Sunrise */
        YE100: 'rgba(245,191,110,1)',
        /** Brand: Teal Glacier */
        TE100: 'rgba(53,155,161,1)',
        /** Brand: Red Rose */
        RE100: 'rgba(207,74,74,1)',
        // #endregion
        // #region Tints & Shades: Brand Blue
        /** Brand Blue: Tint 200 */
        BB200: 'rgba(14,27,76,1)',
        /** Brand Blue: Tint 190 */
        BB190: 'rgba(15,29,80,1)',
        /** Brand Blue: Tint 180 */
        BB180: 'rgba(18,33,86,1)',
        /** Brand Blue: Tint 170 */
        BB170: 'rgba(21,38,97,1)',
        /** Brand Blue: Tint 160 */
        BB160: 'rgba(26,45,112,1)',
        /** Brand Blue: Tint 150 */
        BB150: 'rgba(33,55,133,1)',
        /** Brand Blue: Tint 140 */
        BB140: 'rgba(42,69,161,1)',
        /** Brand Blue: Tint 130 */
        BB130: 'rgba(48,77,178,1)',
        /** Brand Blue: Tint 120 */
        BB120: 'rgba(54,86,195,1)',
        /** Brand Blue: Tint 110 */
        BB110: 'rgba(60,95,213,1)',
        /** Brand Blue: Tint 90 */
        BB90: 'rgba(91,137,237,1)',
        /** Brand Blue: Tint 80 */
        BB80: 'rgba(117,164,240,1)',
        /** Brand Blue: Tint 70 */
        BB70: 'rgba(143,192,248,1)',
        /** Brand Blue: Tint 60 */
        BB60: 'rgba(172,212,251,1)',
        /** Brand Blue: Tint 50 */
        BB50: 'rgba(197,227,252,1)',
        /** Brand Blue: Tint 40 */
        BB40: 'rgba(210,235,254,1)',
        /** Brand Blue: Tint 30 */
        BB30: 'rgba(222,240,254,1)',
        /** Brand Blue: Tint 20 */
        BB20: 'rgba(235,247,255,1)',
        /** Brand Blue: Tint 10 */
        BB10: 'rgba(247,252,255,1)',
        /** Brand Blue: Tint 90 (Transparent) */
        BB90T: 'rgba(28,91,229,0.720)',
        /** Brand Blue: Tint 80 (Transparent) */
        BB80T: 'rgba(21,101,229,0.590)',
        /** Brand Blue: Tint 70 (Transparent) */
        BB70T: 'rgba(22,123,240,0.480)',
        /** Brand Blue: Tint 60 (Transparent) */
        BB60T: 'rgba(17,133,242,0.350)',
        /** Brand Blue: Tint 50 (Transparent) */
        BB50T: 'rgba(12,139,242,0.240)',
        /** Brand Blue: Tint 40 (Transparent) */
        BB40T: 'rgba(0,144,255,0.170)',
        /** Brand Blue: Tint 30 (Transparent) */
        BB30T: 'rgba(0,144,255,0.130)',
        /** Brand Blue: Tint 20 (Transparent) */
        BB20T: 'rgba(0,149,255,0.080)',
        /** Brand Blue: Tint 10 (Transparent) */
        BB10T: 'rgba(0,157,255,0.030)',
        // #endregion
        // #region Tints & Shades: Green Pine
        /** Green Pine: Tint 200 */
        GR200: 'rgba(17,46,35,1)',
        /** Green Pine: Tint 190 */
        GR190: 'rgba(18,48,37,1)',
        /** Green Pine: Tint 180 */
        GR180: 'rgba(19,51,40,1)',
        /** Green Pine: Tint 170 */
        GR170: 'rgba(22,57,44,1)',
        /** Green Pine: Tint 160 */
        GR160: 'rgba(25,65,50,1)',
        /** Green Pine: Tint 150 */
        GR150: 'rgba(29,77,59,1)',
        /** Green Pine: Tint 140 */
        GR140: 'rgba(35,92,71,1)',
        /** Green Pine: Tint 130 */
        GR130: 'rgba(38,101,78,1)',
        /** Green Pine: Tint 120 */
        GR120: 'rgba(42,110,85,1)',
        /** Green Pine: Tint 110 */
        GR110: 'rgba(45,120,92,1)',
        /** Green Pine: Tint 90 */
        GR90: 'rgba(71,159,127,1)',
        /** Green Pine: Tint 80 */
        GR80: 'rgba(105,187,157,1)',
        /** Green Pine: Tint 70 */
        GR70: 'rgba(133,213,184,1)',
        /** Green Pine: Tint 60 */
        GR60: 'rgba(166,230,206,1)',
        /** Green Pine: Tint 50 */
        GR50: 'rgba(194,243,225,1)',
        /** Green Pine: Tint 40 */
        GR40: 'rgba(209,247,233,1)',
        /** Green Pine: Tint 30 */
        GR30: 'rgba(222,250,240,1)',
        /** Green Pine: Tint 20 */
        GR20: 'rgba(235,253,246,1)',
        /** Green Pine: Tint 10 */
        GR10: 'rgba(247,255,252,1)',
        /** Green Pine: Tint 90 (Transparent) */
        GR90T: 'rgba(0,122,78,0.720)',
        /** Green Pine: Tint 80 (Transparent) */
        GR80T: 'rgba(0,140,89,0.590)',
        /** Green Pine: Tint 70 (Transparent) */
        GR70T: 'rgba(0,168,107,0.480)',
        /** Green Pine: Tint 60 (Transparent) */
        GR60T: 'rgba(0,184,116,0.350)',
        /** Green Pine: Tint 50 (Transparent) */
        GR50T: 'rgba(0,207,131,0.240)',
        /** Green Pine: Tint 40 (Transparent) */
        GR40T: 'rgba(0,212,134,0.180)',
        /** Green Pine: Tint 30 (Transparent) */
        GR30T: 'rgba(0,219,139,0.130)',
        /** Green Pine: Tint 20 (Transparent) */
        GR20T: 'rgba(0,235,149,0.080)',
        /** Green Pine: Tint 10 (Transparent) */
        GR10T: 'rgba(0,255,161,0.030)',
        // #endregion
        // #region Tints & Shades: Pink Coral
        /** Pink Coral: Tint 200 */
        PI200: 'rgba(89,43,42,1)',
        /** Pink Coral: Tint 190 */
        PI190: 'rgba(92,45,44,1)',
        /** Pink Coral: Tint 180 */
        PI180: 'rgba(98,49,48,1)',
        /** Pink Coral: Tint 170 */
        PI170: 'rgba(108,55,54,1)',
        /** Pink Coral: Tint 160 */
        PI160: 'rgba(123,63,62,1)',
        /** Pink Coral: Tint 150 */
        PI150: 'rgba(143,75,74,1)',
        /** Pink Coral: Tint 140 */
        PI140: 'rgba(169,90,89,1)',
        /** Pink Coral: Tint 130 */
        PI130: 'rgba(186,100,99,1)',
        /** Pink Coral: Tint 120 */
        PI120: 'rgba(202,110,108,1)',
        /** Pink Coral: Tint 110 */
        PI110: 'rgba(219,120,119,1)',
        /** Pink Coral: Tint 90 */
        PI90: 'rgba(242,147,146,1)',
        /** Pink Coral: Tint 80 */
        PI80: 'rgba(246,165,164,1)',
        /** Pink Coral: Tint 70 */
        PI70: 'rgba(247,183,182,1)',
        /** Pink Coral: Tint 60 */
        PI60: 'rgba(249,198,197,1)',
        /** Pink Coral: Tint 50 */
        PI50: 'rgba(253,216,216,1)',
        /** Pink Coral: Tint 40 */
        PI40: 'rgba(255,225,224,1)',
        /** Pink Coral: Tint 30 */
        PI30: 'rgba(255,232,232,1)',
        /** Pink Coral: Tint 20 */
        PI20: 'rgba(255,240,240,1)',
        /** Pink Coral: Tint 10 */
        PI10: 'rgba(255,248,247,1)',
        /** Pink Coral: Tint 90 (Transparent) */
        PI90T: 'rgba(229,35,32,0.490)',
        /** Pink Coral: Tint 80 (Transparent) */
        PI80T: 'rgba(232,31,28,0.400)',
        /** Pink Coral: Tint 70 (Transparent) */
        PI70T: 'rgba(229,24,21,0.310)',
        /** Pink Coral: Tint 60 (Transparent) */
        PI60T: 'rgba(229,17,14,0.240)',
        /** Pink Coral: Tint 50 (Transparent) */
        PI50T: 'rgba(245,14,10,0.160)',
        /** Pink Coral: Tint 40 (Transparent) */
        PI40T: 'rgba(255,4,0,0.120)',
        /** Pink Coral: Tint 30 (Transparent) */
        PI30T: 'rgba(255,4,0,0.090)',
        /** Pink Coral: Tint 20 (Transparent) */
        PI20T: 'rgba(255,4,0,0.060)',
        /** Pink Coral: Tint 10 (Transparent) */
        PI10T: 'rgba(255,4,0,0.030)',
        // #endregion
        // #region Tints & Shades: Purple Heather
        /** Purple Heather: Tint 200 */
        PU200: 'rgba(50,18,59,1)',
        /** Purple Heather: Tint 190 */
        PU190: 'rgba(52,20,61,1)',
        /** Purple Heather: Tint 180 */
        PU180: 'rgba(55,23,64,1)',
        /** Purple Heather: Tint 170 */
        PU170: 'rgba(61,27,71,1)',
        /** Purple Heather: Tint 160 */
        PU160: 'rgba(69,33,79,1)',
        /** Purple Heather: Tint 150 */
        PU150: 'rgba(81,40,92,1)',
        /** Purple Heather: Tint 140 */
        PU140: 'rgba(96,50,109,1)',
        /** Purple Heather: Tint 130 */
        PU130: 'rgba(105,56,119,1)',
        /** Purple Heather: Tint 120 */
        PU120: 'rgba(115,63,129,1)',
        /** Purple Heather: Tint 110 */
        PU110: 'rgba(124,70,139,1)',
        /** Purple Heather: Tint 90 */
        PU90: 'rgba(158,100,174,1)',
        /** Purple Heather: Tint 80 */
        PU80: 'rgba(183,129,198,1)',
        /** Purple Heather: Tint 70 */
        PU70: 'rgba(204,157,217,1)',
        /** Purple Heather: Tint 60 */
        PU60: 'rgba(223,182,234,1)',
        /** Purple Heather: Tint 50 */
        PU50: 'rgba(236,207,244,1)',
        /** Purple Heather: Tint 40 */
        PU40: 'rgba(240,217,246,1)',
        /** Purple Heather: Tint 30 */
        PU30: 'rgba(245,227,250,1)',
        /** Purple Heather: Tint 20 */
        PU20: 'rgba(250,237,253,1)',
        /** Purple Heather: Tint 10 */
        PU10: 'rgba(253,247,255,1)',
        /** Purple Heather: Tint 90 (Transparent) */
        PU90T: 'rgba(99,5,125,0.620)',
        /** Purple Heather: Tint 80 (Transparent) */
        PU80T: 'rgba(110,3,140,0.500)',
        /** Purple Heather: Tint 70 (Transparent) */
        PU70T: 'rgba(125,3,158,0.390)',
        /** Purple Heather: Tint 60 (Transparent) */
        PU60T: 'rgba(144,2,184,0.290)',
        /** Purple Heather: Tint 50 (Transparent) */
        PU50T: 'rgba(156,2,199,0.190)',
        /** Purple Heather: Tint 40 (Transparent) */
        PU40T: 'rgba(154,2,196,0.150)',
        /** Purple Heather: Tint 30 (Transparent) */
        PU30T: 'rgba(166,2,212,0.110)',
        /** Purple Heather: Tint 20 (Transparent) */
        PU20T: 'rgba(180,2,229,0.070)',
        /** Purple Heather: Tint 10 (Transparent) */
        PU10T: 'rgba(200,0,255,0.030)',
        // #endregion
        // #region Tints & Shades: Yellow Sunrise
        /** Yellow Sunrise: Tint 200 */
        YE200: 'rgba(74,49,11,1)',
        /** Yellow Sunrise: Tint 190 */
        YE190: 'rgba(78,52,15,1)',
        /** Yellow Sunrise: Tint 180 */
        YE180: 'rgba(85,59,19,1)',
        /** Yellow Sunrise: Tint 170 */
        YE170: 'rgba(96,68,25,1)',
        /** Yellow Sunrise: Tint 160 */
        YE160: 'rgba(113,81,34,1)',
        /** Yellow Sunrise: Tint 150 */
        YE150: 'rgba(137,100,46,1)',
        /** Yellow Sunrise: Tint 140 */
        YE140: 'rgba(167,126,63,1)',
        /** Yellow Sunrise: Tint 130 */
        YE130: 'rgba(186,141,73,1)',
        /** Yellow Sunrise: Tint 120 */
        YE120: 'rgba(205,157,84,1)',
        /** Yellow Sunrise: Tint 110 */
        YE110: 'rgba(225,174,97,1)',
        /** Yellow Sunrise: Tint 90 */
        YE90: 'rgba(247,200,129,1)',
        /** Yellow Sunrise: Tint 80 */
        YE80: 'rgba(251,210,148,1)',
        /** Yellow Sunrise: Tint 70 */
        YE70: 'rgba(253,219,169,1)',
        /** Yellow Sunrise: Tint 60 */
        YE60: 'rgba(253,228,190,1)',
        /** Yellow Sunrise: Tint 50 */
        YE50: 'rgba(255,236,209,1)',
        /** Yellow Sunrise: Tint 40 */
        YE40: 'rgba(255,241,219,1)',
        /** Yellow Sunrise: Tint 30 */
        YE30: 'rgba(255,244,227,1)',
        /** Yellow Sunrise: Tint 20 */
        YE20: 'rgba(255,248,237,1)',
        /** Yellow Sunrise: Tint 10 */
        YE10: 'rgba(255,252,247,1)',
        /** Yellow Sunrise: Tint 90 (Transparent) */
        YE90T: 'rgba(240,147,7,0.510)',
        /** Yellow Sunrise: Tint 80 (Transparent) */
        YE80T: 'rgba(245,149,5,0.430)',
        /** Yellow Sunrise: Tint 70 (Transparent) */
        YE70T: 'rgba(247,150,2,0.340)',
        /** Yellow Sunrise: Tint 60 (Transparent) */
        YE60T: 'rgba(247,151,5,0.260)',
        /** Yellow Sunrise: Tint 50 (Transparent) */
        YE50T: 'rgba(254,152,0,0.180)',
        /** Yellow Sunrise: Tint 40 (Transparent) */
        YE40T: 'rgba(254,155,0,0.140)',
        /** Yellow Sunrise: Tint 30 (Transparent) */
        YE30T: 'rgba(255,151,0,0.110)',
        /** Yellow Sunrise: Tint 20 (Transparent) */
        YE20T: 'rgba(255,150,0,0.070)',
        /** Yellow Sunrise: Tint 10 (Transparent) */
        YE10T: 'rgba(255,159,0,0.030)',
        // #endregion
        // #region Tints & Shades: Teal Glacier
        /** Teal Glacier: Tint 200 */
        TE200: 'rgba(12,42,43,1)',
        /** Teal Glacier: Tint 190 */
        TE190: 'rgba(13,44,46,1)',
        /** Teal Glacier: Tint 180 */
        TE180: 'rgba(15,49,51,1)',
        /** Teal Glacier: Tint 170 */
        TE170: 'rgba(17,57,59,1)',
        /** Teal Glacier: Tint 160 */
        TE160: 'rgba(21,68,70,1)',
        /** Teal Glacier: Tint 150 */
        TE150: 'rgba(27,83,86,1)',
        /** Teal Glacier: Tint 140 */
        TE140: 'rgba(34,104,108,1)',
        /** Teal Glacier: Tint 130 */
        TE130: 'rgba(38,116,121,1)',
        /** Teal Glacier: Tint 120 */
        TE120: 'rgba(43,129,133,1)',
        /** Teal Glacier: Tint 110 */
        TE110: 'rgba(48,142,147,1)',
        /** Teal Glacier: Tint 90 */
        TE90: 'rgba(78,175,181,1)',
        /** Teal Glacier: Tint 80 */
        TE80: 'rgba(105,199,204,1)',
        /** Teal Glacier: Tint 70 */
        TE70: 'rgba(134,219,224,1)',
        /** Teal Glacier: Tint 60 */
        TE60: 'rgba(167,233,237,1)',
        /** Teal Glacier: Tint 50 */
        TE50: 'rgba(192,243,246,1)',
        /** Teal Glacier: Tint 40 */
        TE40: 'rgba(209,248,250,1)',
        /** Teal Glacier: Tint 30 */
        TE30: 'rgba(221,251,253,1)',
        /** Teal Glacier: Tint 20 */
        TE20: 'rgba(233,253,254,1)',
        /** Teal Glacier: Tint 10 */
        TE10: 'rgba(247,255,255,1)',
        /** Teal Glacier: Tint 90 (Transparent) */
        TE90T: 'rgba(12,145,153,0.730)',
        /** Teal Glacier: Tint 80 (Transparent) */
        TE80T: 'rgba(14,164,173,0.620)',
        /** Teal Glacier: Tint 70 (Transparent) */
        TE70T: 'rgba(14,184,194,0.500)',
        /** Teal Glacier: Tint 60 (Transparent) */
        TE60T: 'rgba(12,193,204,0.360)',
        /** Teal Glacier: Tint 50 (Transparent) */
        TE50T: 'rgba(13,210,222,0.260)',
        /** Teal Glacier: Tint 40 (Transparent) */
        TE40T: 'rgba(11,217,229,0.190)',
        /** Teal Glacier: Tint 30 (Transparent) */
        TE30T: 'rgba(10,227,240,0.140)',
        /** Teal Glacier: Tint 20 (Transparent) */
        TE20T: 'rgba(5,229,242,0.090)',
        /** Teal Glacier: Tint 10 (Transparent) */
        TE10T: 'rgba(0,255,255,0.030)',
        // #endregion
        // #region Tints & Shades: Red Rose
        /** Red Rose: Tint 200 */
        RE200: 'rgba(82,25,25,1)',
        /** Red Rose: Tint 190 */
        RE190: 'rgba(84,27,27,1)',
        /** Red Rose: Tint 180 */
        RE180: 'rgba(90,29,29,1)',
        /** Red Rose: Tint 170 */
        RE170: 'rgba(98,32,32,1)',
        /** Red Rose: Tint 160 */
        RE160: 'rgba(110,37,37,1)',
        /** Red Rose: Tint 150 */
        RE150: 'rgba(128,43,43,1)',
        /** Red Rose: Tint 140 */
        RE140: 'rgba(150,52,52,1)',
        /** Red Rose: Tint 130 */
        RE130: 'rgba(164,57,57,1)',
        /** Red Rose: Tint 120 */
        RE120: 'rgba(178,62,62,1)',
        /** Red Rose: Tint 110 */
        RE110: 'rgba(192,68,68,1)',
        /** Red Rose: Tint 90 */
        RE90: 'rgba(217,98,98,1)',
        /** Red Rose: Tint 80 */
        RE80: 'rgba(230,121,121,1)',
        /** Red Rose: Tint 70 */
        RE70: 'rgba(240,148,148,1)',
        /** Red Rose: Tint 60 */
        RE60: 'rgba(246,175,175,1)',
        /** Red Rose: Tint 50 */
        RE50: 'rgba(249,199,199,1)',
        /** Red Rose: Tint 40 */
        RE40: 'rgba(252,211,211,1)',
        /** Red Rose: Tint 30 */
        RE30: 'rgba(255,224,224,1)',
        /** Red Rose: Tint 20 */
        RE20: 'rgba(255,237,237,1)',
        /** Red Rose: Tint 10 */
        RE10: 'rgba(255,247,247,1)',
        /** Red Rose: Tint 90 (Transparent) */
        RE90T: 'rgba(204,43,43,0.740)',
        /** Red Rose: Tint 80 (Transparent) */
        RE80T: 'rgba(214,39,39,0.620)',
        /** Red Rose: Tint 70 (Transparent) */
        RE70T: 'rgba(224,36,36,0.490)',
        /** Red Rose: Tint 60 (Transparent) */
        RE60T: 'rgba(229,28,28,0.350)',
        /** Red Rose: Tint 50 (Transparent) */
        RE50T: 'rgba(232,23,23,0.240)',
        /** Red Rose: Tint 40 (Transparent) */
        RE40T: 'rgba(240,12,12,0.180)',
        /** Red Rose: Tint 30 (Transparent) */
        RE30T: 'rgba(254,0,0,0.120)',
        /** Red Rose: Tint 20 (Transparent) */
        RE20T: 'rgba(254,0,0,0.070)',
        /** Red Rose: Tint 10 (Transparent) */
        RE10T: 'rgba(255,0,0,0.030)',
        // #endregion
        // #region Neutrals (Light mode)
        /** Neutrals: NU140 (Light mode) */
        LM_NU140: 'rgba(5,11,26,1)',
        /** Neutrals: NU130 (Light mode) */
        LM_NU130: 'rgba(9,17,35,1)',
        /** Neutrals: NU120 (Light mode) */
        LM_NU120: 'rgba(14,25,46,1)',
        /** Neutrals: NU110 (Light mode) */
        LM_NU110: 'rgba(15,30,52,1)',
        /** Neutrals: NU100 (Light mode) */
        LM_NU100: 'rgba(17,35,58,1)',
        /** Neutrals: NU90 (Light mode) */
        LM_NU90: 'rgba(31,47,70,1)',
        /** Neutrals: NU80 (Light mode) */
        LM_NU80: 'rgba(57,71,92,1)',
        /** Neutrals: NU70 (Light mode) */
        LM_NU70: 'rgba(100,111,127,1)',
        /** Neutrals: NU60 (Light mode) */
        LM_NU60: 'rgba(154,161,176,1)',
        /** Neutrals: NU50 (Light mode) */
        LM_NU50: 'rgba(201,206,217,1)',
        /** Neutrals: NU40 (Light mode) */
        LM_NU40: 'rgba(215,219,230,1)',
        /** Neutrals: NU30 (Light mode) */
        LM_NU30: 'rgba(230,234,242,1)',
        /** Neutrals: NU20 (Light mode) */
        LM_NU20: 'rgba(240,242,247,1)',
        /** Neutrals: NU10 (Light mode) */
        LM_NU10: 'rgba(248,249,251,1)',
        /** Neutrals: NU0 (Light mode) */
        LM_NU0: 'rgba(255,255,255,1)',
        /** Neutrals: NU90 (Transparent) (Light mode) */
        LM_NU90T: 'rgba(17,34,58,0.940)',
        /** Neutrals: NU80 (Transparent) (Light mode) */
        LM_NU80T: 'rgba(17,34,58,0.830)',
        /** Neutrals: NU70 (Transparent) (Light mode) */
        LM_NU70T: 'rgba(17,34,58,0.650)',
        /** Neutrals: NU60 (Transparent) (Light mode) */
        LM_NU60T: 'rgba(10,27,62,0.410)',
        /** Neutrals: NU50 (Transparent) (Light mode) */
        LM_NU50T: 'rgba(8,30,84,0.220)',
        /** Neutrals: NU40 (Transparent) (Light mode) */
        LM_NU40T: 'rgba(7,34,100,0.160)',
        /** Neutrals: NU30 (Transparent) (Light mode) */
        LM_NU30T: 'rgba(5,42,128,0.100)',
        /** Neutrals: NU20 (Transparent) (Light mode) */
        LM_NU20T: 'rgba(3,40,114,0.060)',
        /** Neutrals: NU10 (Transparent) (Light mode) */
        LM_NU10T: 'rgba(4,40,114,0.030)',
        // #endregion
        // #region Behavioural
        /** Behavioural: Positive 120 */
        PO120: 'rgba(42,110,85,1)',
        /** Behavioural: Positive 110 */
        PO110: 'rgba(45,120,92,1)',
        /** Behavioural: Positive 100 */
        PO100: 'rgba(49,130,100,1)',
        /** Behavioural: Positive 90 */
        PO90: 'rgba(71,159,127,1)',
        /** Behavioural: Positive 80 */
        PO80: 'rgba(105,187,157,1)',
        /** Behavioural: Negative 120 */
        NE120: 'rgba(178,62,62,1)',
        /** Behavioural: Negative 110 */
        NE110: 'rgba(192,68,68,1)',
        /** Behavioural: Negative 100 */
        NE100: 'rgba(207,74,74,1)',
        /** Behavioural: Negative 90 */
        NE90: 'rgba(217,98,98,1)',
        /** Behavioural: Negative 80 */
        NE80: 'rgba(230,121,121,1)',
        /** Behavioural: Warning 120 */
        WA120: 'rgba(205,157,84,1)',
        /** Behavioural: Warning 110 */
        WA110: 'rgba(225,174,97,1)',
        /** Behavioural: Warning 100 */
        WA100: 'rgba(245,191,110,1)',
        /** Behavioural: Warning 90 */
        WA90: 'rgba(247,200,129,1)',
        /** Behavioural: Warning 80 */
        WA80: 'rgba(251,210,148,1)',
        /** Whites: Tint 100 */
        WH100: 'rgba(255,255,255,1)',
        /** Whites: Tint 90 (Transparent) */
        WH90T: 'rgba(255,255,255,0.970)',
        /** Whites: Tint 80 (Transparent) */
        WH80T: 'rgba(255,255,255,0.940)',
        /** Whites: Tint 70 (Transparent) */
        WH70T: 'rgba(255,255,255,0.900)',
        /** Whites: Tint 60 (Transparent) */
        WH60T: 'rgba(255,255,255,0.840)',
        /** Whites: Tint 50 (Transparent) */
        WH50T: 'rgba(255,255,255,0.780)',
        /** Whites: Tint 40 (Transparent) */
        WH40T: 'rgba(255,255,255,0.590)',
        /** Whites: Tint 30 (Transparent) */
        WH30T: 'rgba(255,255,255,0.350)',
        /** Whites: Tint 20 (Transparent) */
        WH20T: 'rgba(255,255,255,0.170)',
        /** Whites: Tint 10 (Transparent) */
        WH10T: 'rgba(255,255,255,0.060)',
        /** Channels: Airbnb */
        Airbnb: 'rgba(255,81,85,1)',
        /** Channels: Booking.com */
        Bookingcom: 'rgba(12,59,124,1)',
        /** Channels: Expedia */
        Expedia: 'rgba(253,219,50,1)',
        /** Channels: Holidu */
        Holidu: 'rgba(0,128,157,1)',
        /** Channels: TripAdvisor */
        Tripadvisor: 'rgba(53,224,161,1)',
        /** Channels: VRBO */
        Vrbo: 'rgba(19,37,77,1)',
        /** Channels: HomeToGo */
        HomeToGo: 'rgba(101,51,205,1)',
        get typography() {
            return {
                heading: theme.colors.LM_NU100,
                body: theme.colors.LM_NU70T,
                label: theme.colors.LM_NU100,
                link: theme.colors.BB100,
                link_hover: theme.colors.BB110,
                link_visited: theme.colors.PU100,
            };
        },
        get interface() {
            return {
                page_background: theme.colors.LM_NU10,
                border: theme.colors.LM_NU30T,
                panel_app_background: 'black',
                selected: theme.colors.BB20T,
            };
        },
        get cards() {
            return {
                bg_white: theme.colors.LM_NU0,
                bg_blue: theme.colors.BB20T,
                bg_green: theme.colors.GR20T,
                bg_pink: theme.colors.PI20T,
            };
        },
        // #endregion
    },
    typography: {
        /** Inter Regular */
        IR70: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '10px',
            letterSpacing: '0.1px'
        },
        IR80: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '12px',
            letterSpacing: '0.01px'
        },
        IR90: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '14px',
            letterSpacing: '-0.09px'
        },
        IR100: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '16px',
            letterSpacing: '-0.18px'
        },
        IR110: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '18px',
            letterSpacing: '-0.26px'
        },
        IR120: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '20px',
            letterSpacing: '-0.33px'
        },
        IR130: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '24px',
            letterSpacing: '-0.47px'
        },
        IR140: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '32px',
            letterSpacing: '-0.69px'
        },
        IR150: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '40px',
            letterSpacing: '-0.89px'
        },
        IR160: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '48px',
            letterSpacing: '-1.07px'
        },
        IR170: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '400',
            fontSize: '64px',
            letterSpacing: '-1.43px'
        },
        /** Inter Medium */
        IM70: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '10px',
            letterSpacing: '0.1px'
        },
        IM80: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '12px',
            letterSpacing: '0.01px'
        },
        IM90: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '14px',
            letterSpacing: '-0.09px'
        },
        IM100: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '16px',
            letterSpacing: '-0.18px'
        },
        IM110: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '18px',
            letterSpacing: '-0.26px'
        },
        IM120: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '20px',
            letterSpacing: '-0.33px'
        },
        IM130: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '24px',
            letterSpacing: '-0.47px'
        },
        IM140: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '32px',
            letterSpacing: '-0.69px'
        },
        IM150: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '40px',
            letterSpacing: '-0.89px'
        },
        IM160: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '48px',
            letterSpacing: '-1.07px'
        },
        IM170: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '500',
            fontSize: '64px',
            letterSpacing: '-1.43px'
        },
        /** Inter Bold */
        IB70: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '10px',
            letterSpacing: '0.1px'
        },
        IB80: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '12px',
            letterSpacing: '0.01px'
        },
        IB90: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '14px',
            letterSpacing: '-0.09px'
        },
        IB100: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '16px',
            letterSpacing: '-0.18px'
        },
        IB110: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '18px',
            letterSpacing: '-0.26px'
        },
        IB120: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '20px',
            letterSpacing: '-0.33px'
        },
        IB130: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '24px',
            letterSpacing: '-0.47px'
        },
        IB140: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '32px',
            letterSpacing: '-0.69px'
        },
        IB150: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '40px',
            letterSpacing: '-0.89px'
        },
        IB160: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '48px',
            letterSpacing: '-1.07px'
        },
        IB170: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: '700',
            fontSize: '64px',
            letterSpacing: '-1.43px'
        },
        /** RalewayTN Bold */
        RWB70: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '10px',
            letterSpacing: '0'
        },
        RWB80: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '12px',
            letterSpacing: '0'
        },
        RWB90: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '14px',
            letterSpacing: '0'
        },
        RWB100: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '16px',
            letterSpacing: '0'
        },
        RWB110: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '18px',
            letterSpacing: '0'
        },
        RWB120: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '20px',
            letterSpacing: '0'
        },
        RWB130: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '24px',
            letterSpacing: '0'
        },
        RWB140: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '32px',
            letterSpacing: '0'
        },
        RWB150: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '40px',
            letterSpacing: '0'
        },
        RWB160: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '48px',
            letterSpacing: '0'
        },
        RWB170: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '700',
            fontSize: '64px',
            letterSpacing: '0'
        },
        /** RalewayTN Extra Bold */
        RWEB70: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '10px',
            letterSpacing: '0'
        },
        RWEB80: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '12px',
            letterSpacing: '0'
        },
        RWEB90: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '14px',
            letterSpacing: '0'
        },
        RWEB100: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '16px',
            letterSpacing: '0'
        },
        RWEB110: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '18px',
            letterSpacing: '0'
        },
        RWEB120: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '20px',
            letterSpacing: '0'
        },
        RWEB130: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '24px',
            letterSpacing: '0'
        },
        RWEB140: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '32px',
            letterSpacing: '0'
        },
        RWEB150: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '40px',
            letterSpacing: '0'
        },
        RWEB160: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '48px',
            letterSpacing: '0'
        },
        RWEB170: {
            fontFamily: 'RalewayTN, sans-serif',
            fontWeight: '800',
            fontSize: '64px',
            letterSpacing: '0'
        },
        lineHeight: {
            sm: '1.25em',
            md: '1.5em',
            lg: '1.75em'
        }
    },
    shadows: {
        shadow10: '0px 2px 8px 0px #0A182B14, 0px 1px 4px 0px #0A182B0D',
        shadow20: '0px 4px 10px 0px #0A182B14, 0px 2px 5px 0px #0A182B0D',
        shadow30: '0px 6px 12px 0px #0A182B14, 0px 3px 6px 0px #0A182B0D',
        shadow40: '0px 8px 14px 0px #0A182B14, 0px 4px 7px 0px #0A182B0D'
    },
    spacing: {
        // TODO: Convert to rem equivalents, consume theme.spacing constants in <Button>
        space10: '4px',
        space20: '8px',
        space30: '12px',
        space40: '16px',
        space50: '24px',
        space60: '32px',
        space70: '44px',
        space80: '64px'
    },
    radii: {
        radii10: '2px',
        radii20: '4px',
        radii30: '8px',
        radii40: '16px',
        radii50: '24px'
    },
    breakpoints: {
        xs: { min: '', max: '576px' },
        sm: { min: '576px', max: '767px' },
        md: { min: '768px', max: '1023px' },
        lg: { min: '1024px', max: '1279px' },
        xl: { min: '1280px', max: '1439px' },
        xxl: { min: '1440px', max: '' },
    }
};
//# sourceMappingURL=index.js.map